/* 
  
  MFSimulator
  
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import TagManager from '@sooro-io/react-gtm-module';
import App from './App';
import './i18n/i18n.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './scss/main.scss';

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import '@fortawesome/fontawesome-svg-core/styles.css';

// MFSim config
import config from './config.json';
import { injectOneTrust } from './utils/onetrust';

// Load all country specific CSS - specific styles will be loaded
// by the top level country class.
import './scss/countries/en.scss';
import './scss/countries/fr-ca.scss';
import './scss/countries/ja-jp.scss';

// Add all FontAwesome icons to the library
library.add(fas);

// Determine environment and initialize appropriate GTM container
const getEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname === 'mfsimulator.jnjvision.com') {
    return 'production';
  }
  // Default to staging for all other environments (staging, localhost, etc.)
  return 'staging';
};

const environment = getEnvironment();
const gtmConfig = config.gtm[environment];

// Initialize Google Tag Manager with environment-specific configuration
const tagManagerArgs = {
  gtmId: gtmConfig.id,
  auth: gtmConfig.auth || undefined,
  preview: gtmConfig.preview || undefined
};
TagManager.initialize(tagManagerArgs);

// Inject OneTrust for users who land directly on /ja-jp.
// Users navigating to /ja-jp via React Router are handled by App.jsx useEffect.
injectOneTrust();

// Dynamically inject environment-specific GTM noscript fallback
const injectGTMNoscript = () => {
  const noscriptContainer = document.getElementById('gtm-noscript');
  if (noscriptContainer) {
    const noscript = document.createElement('noscript');
    let iframeSrc = `https://www.googletagmanager.com/ns.html?id=${gtmConfig.id}`;
    
    // Add auth and preview params for staging
    if (gtmConfig.auth && gtmConfig.preview) {
      iframeSrc += `&gtm_auth=${gtmConfig.auth}&gtm_preview=${gtmConfig.preview}&gtm_cookies_win=x`;
    }
    
    const iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    
    noscript.appendChild(iframe);
    noscriptContainer.appendChild(noscript);
  }
};
injectGTMNoscript();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App config={config} />
  </BrowserRouter>
);

// Dynamically set the --vh variable to account for browser UI on mobile devices
const setViewportHeight = () => {
	const vh = window.innerHeight * 0.01; // Calculate 1% of the viewport height
	document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Set the --vh variable on load and resize
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);
setViewportHeight(); // Initial call
